import styles from "./SingleBarChart.module.scss";

interface SingleBarChartProps {
  percentValue?: number;
  barColor?: string;
  trackColor?: string;
  height?: number;
  isLoading?: boolean;
}

const SingleBarChart = ({
  percentValue = 0,
  barColor = "#1778E1",
  trackColor = "#e7e7e7",
  height = 8,
  isLoading = false,
}: SingleBarChartProps) => {
  const normalizedPercentValue = isLoading
    ? 0
    : Math.max(0, Math.min(100, percentValue));

  const borderRadius = Math.ceil(height / 2);

  const trackStyle: React.CSSProperties = {
    width: "100%",
    height,
    borderRadius,
  };

  if (!isLoading) {
    trackStyle.backgroundColor = trackColor;
  }

  const barStyle: React.CSSProperties = {
    width: `${normalizedPercentValue}%`,
    height,
    backgroundColor: barColor,
    borderRadius,
  };

  return (
    <div
      style={trackStyle}
      className={isLoading ? styles["animated-background"] : ""}
    >
      <div style={barStyle}></div>
    </div>
  );
};

export default SingleBarChart;
